const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit * 3,
    width: '50%'
  },
  content: {
    margin: '0 !important'
  }
});

export default styles;
